import * as React from "react";

const SVGHolder = ({ type, inline }) => (
  <div className={`svgHolder svgHolder--${type}${inline ? " svgHolder--inline" : ""}`}>
    {type === "edit" && (
      <svg xmlns="http://www.w3.org/2000/svg" width="15.596" height="15.596" viewBox="0 0 15.596 15.596">
        <g transform="translate(-2.25 -1.933)">
          <path className="a" d="M9.245,6H4.388A1.388,1.388,0,0,0,3,7.388V17.1a1.388,1.388,0,0,0,1.388,1.388H14.1A1.388,1.388,0,0,0,15.489,17.1V12.245" transform="translate(0 -1.71)" />
          <path className="a" d="M19.285,3.249a1.472,1.472,0,1,1,2.082,2.082l-6.591,6.591L12,12.616l.694-2.775Z" transform="translate(-4.837)" />
        </g>
      </svg>
    )}
    {type === "upload" && (
      <svg xmlns="http://www.w3.org/2000/svg" width="15.91" height="15.91" viewBox="0 0 15.91 15.91">
        <g transform="translate(-3.5 -3.5)">
          <path className="a" d="M18.41,22.5v3.091a1.546,1.546,0,0,1-1.546,1.546H6.046A1.546,1.546,0,0,1,4.5,25.591V22.5" transform="translate(0 -8.727)" />
          <path className="a" d="M18.228,8.364,14.364,4.5,10.5,8.364" transform="translate(-2.909)" />
          <path className="a" d="M18,4.5v9.273" transform="translate(-6.545)" />
        </g>
      </svg>
    )}
  </div>
);

export default SVGHolder;



// WEBPACK FOOTER //
// ./src/components/SVGHolder.tsx